import { IJob } from "@types";

import classNames from "classnames";
import Link from "next/link";

import { Job } from "../../molecules/Job";

export interface WorkExperienceProps {
  jobs: IJob[];
}

const WorkExperience = ({ jobs }: WorkExperienceProps) => {
  return (
    <>
      {jobs.map(
        (
          {
            company,
            jobTitle,
            fromDate,
            toDate,
            technologies,
            shortDescription,
          },
          index
        ) => (
          <Link href={`/experience/${index}`} key={index}>
            <div
              className={classNames(
                "flex transition-all transform-gpu md:hover:-translate-y-4 cursor-pointer ",
                {
                  "justify-end": index % 2 !== 0,
                }
              )}
              key={`${company} ${jobTitle}`}
            >
              <Job
                company={company}
                jobTitle={jobTitle}
                fromDate={fromDate}
                toDate={toDate}
                technologies={technologies}
                shortDescription={shortDescription}
                index={index}
              ></Job>
            </div>
          </Link>
        )
      )}
    </>
  );
};

export { WorkExperience };
